(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7241,9789,2657],{

/***/ 88518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SEOFORTAG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15072);
/* harmony import */ var src_constants_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38864);




var baseSEO = {
    title: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_TITLE */ .qN,
    description: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_DESC */ .a0,
    openGraph: {
        type: "article",
        locale: "th_TH",
        url: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_URL.WEB */ .h$.WEB,
        title: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_TITLE */ .qN,
        description: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_DESC */ .a0,
        site_name: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_NAME */ .Ey,
        images: [
            {
                url: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .IMAGE_DEFAULT */ .TH,
                width: "750",
                height: "422",
                alt: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_NAME */ .Ey
            }
        ]
    },
    additionalMetaTags: [
        {
            name: "keywords",
            content: src_constants_layout__WEBPACK_IMPORTED_MODULE_1__/* .WEB_KEYWORD */ .kG
        }
    ]
};
var SEO = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, baseSEO), {
    noindex: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn,
    nofollow: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn
});
var SEOFORTAG = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, baseSEO), {
    noindex: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .IS_NO_ROBOT_INDEX */ .wn,
    nofollow: false
});

/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WidgetHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2777);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(186);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(477);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  align-items: baseline;\n  border-bottom: 3px solid var(--primary-color);\n\n  h2 {\n    background: var(--white-color);\n    color: var(--text-color);\n    width: fit-content;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n    padding: 5px 15px 5px 0px;\n    border-radius: 10px 10px 0 0px;\n    font-size: 28pt;\n    font-weight: 400;\n    margin-bottom: -13px;\n    letter-spacing: 0px;\n    text-transform: uppercase;\n\n    @media (max-width: 768px) {\n      font-size: 24pt;\n    }\n    // @media (max-width: 768px) {\n    //   font-family: 'DBHelvethaicaXBd', sans-serif;\n    //   font-weight: 500;\n    // }\n    span {\n      color: #f10300;\n    }\n  }\n  a h2 {\n    cursor: pointer;\n    transition: all 0.5s ease-out;\n    :hover {\n      transform: scale(1.05);\n    }\n  }\n  .text-read {\n    color: var(--primary-color);\n    cursor: pointer;\n    font-size: 12pt;\n    font-weight: 500;\n    background: var(--white-color);\n    margin-bottom: -10px;\n    padding-left: 10px;\n\n    /* padding-bottom: 8px; */\n    svg {\n      color: var(--primary-color);\n      margin-left: -3px;\n    }\n    &:hover {\n      svg {\n        color: var(--hover-color);\n      }\n      color: var(--hover-color);\n    }\n  }\n\n  .heading {\n    &.--hover {\n      &:hover {\n        color: #0600e7;\n      }\n    }\n    &.--live {\n      font-size: 24pt;\n    }\n  }\n\n  .live-button {\n    svg {\n      margin-right: 7px;\n      margin-bottom: 4px;\n    }\n    svg path {\n      fill: red;\n      /* Copy this @keyframes block to your CSS*/\n      @keyframes signalanimate {\n        0% {\n          opacity: 0;\n        }\n        50% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0;\n        }\n      }\n      &:nth-of-type(1) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n      }\n      &:nth-of-type(2) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 0.5s;\n        animation-delay: 0.5s;\n      }\n      &:nth-of-type(3) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function WidgetHeading(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, customHeading = param.customHeading, _className = param.className, className = _className === void 0 ? "" : _className, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _link = param.link, link = _link === void 0 ? "" : _link, _isSectionLive = param.isSectionLive, isSectionLive = _isSectionLive === void 0 ? false : _isSectionLive;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(heading)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "widget-heading ".concat(className),
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            isSectionLive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                className: "heading --live",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "live-button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                x: "0px",
                                y: "0px",
                                width: "17px",
                                height: "15.8px",
                                viewBox: "0 0 17 15.8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,6.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C10.2,7.6,9.5,6.8,8.5,6.8z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M13.6,8.5c0-2.8-2.2-5.1-5-5.2c-2.8,0-5.1,2.2-5.2,5c0,0,0,0.1,0,0.1c0,1.8,1,3.5,2.6,4.4l0.9-1.4c-1.6-1-2.1-3-1.2-4.6s3-2.1,4.6-1.2c1,0.6,1.7,1.7,1.7,2.9c0,1.2-0.6,2.3-1.7,2.9l0.9,1.4C12.7,12,13.6,10.3,13.6,8.5L13.6,8.5z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,0C3.8,0,0,3.8,0,8.5c0,3,1.6,5.8,4.3,7.3l0.9-1.4c-3.3-1.9-4.4-6.1-2.5-9.3s6.1-4.4,9.3-2.5c2.1,1.2,3.4,3.5,3.4,5.9c0,2.4-1.3,4.7-3.4,5.9l0.9,1.4c4.1-2.3,5.5-7.5,3.1-11.6C14.4,1.6,11.6,0,8.5,0z"
                                    })
                                ]
                            }),
                            "LIVE"
                        ]
                    }),
                    " ",
                    "เกาะติดเลือกตั้ง"
                ]
            }) : link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    className: "heading ".concat(link ? "--hover" : ""),
                    children: heading
                })
            }) : customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "heading ".concat(link ? "--hover" : ""),
                children: heading
            }),
            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "text-read",
                    children: [
                        "ดูทั้งหมด ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__.FiArrowRightCircle, {})
                    ]
                })
            })
        ]
    });
};
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());


/***/ }),

/***/ 9789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62019);
/* harmony import */ var dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_th__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40683);
/* harmony import */ var dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87771);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7696);
/* harmony import */ var src_components_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84334);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39334);
/* harmony import */ var src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20464);














dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_buddhistEra__WEBPACK_IMPORTED_MODULE_3___default()));
var CardH = function(param) {
    var data = param.data, _large = param.large, large = _large === void 0 ? false : _large, _description = param.description, description = _description === void 0 ? false : _description, _withMB = param.withMB, withMB = _withMB === void 0 ? null : _withMB, _txtStyle = param.txtStyle, txtStyle = _txtStyle === void 0 ? false : _txtStyle, _external = param.external, external = _external === void 0 ? false : _external, _eyeBall = param.eyeBall, eyeBall = _eyeBall === void 0 ? true : _eyeBall, eventDataLayer = param.eventDataLayer, heading = param.heading, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _isVideo = param.isVideo, isVideo = _isVideo === void 0 ? false : _isVideo, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _isH3 = param.isH3, isH3 = _isH3 === void 0 ? true : _isH3, _showBlurb = param.showBlurb, showBlurb = _showBlurb === void 0 ? false : _showBlurb, _showBadge = param.showBadge, showBadge = _showBadge === void 0 ? false : _showBadge, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0), countView = ref4[0], setCountView = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,src_utils_increment_countview__WEBPACK_IMPORTED_MODULE_10__/* .incrementCountview */ .x)(data).then(function(item) {
            return setCountView(item);
        }).catch(function() {
            return setCountView(0);
        });
    }, []);
    var categoryNameTH = (data === null || data === void 0 ? void 0 : (ref = data.subCategory) === null || ref === void 0 ? void 0 : ref.th) ? data === null || data === void 0 ? void 0 : (ref1 = data.subCategory) === null || ref1 === void 0 ? void 0 : ref1.th : data === null || data === void 0 ? void 0 : (ref2 = data.section) === null || ref2 === void 0 ? void 0 : ref2.th;
    var dateUpdate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(data === null || data === void 0 ? void 0 : data.published_at).locale("th").format("DD MMM BBBB | H:mm");
    var conditionBadge = showBadge && (0,src_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .convertBadge */ .lC)(data, false);
    // console.log(data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: external ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            //! DATALAYER
            target: "_blank",
            rel: "noopener noreferrer",
            className: "card-wrapper",
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                external: external,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            isVideo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiPlayCircleLine */ .YEk, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "read-more",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "อ่านต่อ..."
                                })
                            }),
                            showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: dateUpdate
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: data === null || data === void 0 ? void 0 : data.link,
            className: "card-wrapper",
            //! DATALAYER
            onClick: function() {
                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, eventDataLayer));
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "card-h ".concat(withMB === null ? "" : withMB),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-thumb ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                image: data === null || data === void 0 ? void 0 : data.image,
                                title: data === null || data === void 0 ? void 0 : data.title,
                                type: large ? "CARD_MEDIUM" : "CARD_SMALL",
                                loading: loading
                            }),
                            (data === null || data === void 0 ? void 0 : (ref3 = data.section) === null || ref3 === void 0 ? void 0 : ref3.th) !== null && large && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "badge",
                                children: categoryNameTH
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card-h-content ".concat(large ? "--large" : ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "card-h-content-title ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.title
                            }),
                            showBlurb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "card-h-content-blurb ".concat(txtStyle ? "--light" : "", " text-excerpt-2"),
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card-h-content-meta ".concat(txtStyle ? "--small" : ""),
                                children: [
                                    conditionBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "meta-badge",
                                        children: conditionBadge
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineClockCircle */ .cjn, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "date",
                                        children: dateUpdate
                                    }),
                                    eyeBall && countView > 0 && countView > Number(src_constants__WEBPACK_IMPORTED_MODULE_7__/* .NEXT_PUBLIC_DEFAULT_COUNT_VIEW */ .d$) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "pageview",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_13__/* .AiOutlineEye */ .Zju, {}),
                                            countView > 999 ? numeral__WEBPACK_IMPORTED_MODULE_4___default()(countView).format("0.0a") : countView
                                        ]
                                    })
                                ]
                            }),
                            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-excerpt-3",
                                children: data === null || data === void 0 ? void 0 : data.blurb
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CardH);


/***/ }),

/***/ 62755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ widget_lotto_check; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/await-to-js/dist/await-to-js.es5.js
var await_to_js_es5 = __webpack_require__(41800);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/utils/client.js







var client = axios/* default.create */.Z.create({
    baseURL: constants/* API_URI */.G9,
    headers: {
        "X-Requested-With": "XMLHttpRequest"
    },
    paramsSerializer: function(params) {
        return lib_default().stringify(params, {
            encodeValuesOnly: true,
            arrayFormat: "brackets"
        });
    }
});
/* harmony default export */ var utils_client = ({
    fetch: client,
    get: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
            var options, defaultData, _tmp, ref, err, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, defaultData = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [];
                        return [
                            4,
                            (0,await_to_js_es5.to)(client.get(path, options))
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], res = ref[1];
                        return [
                            2,
                            err ? defaultData : res.data
                        ];
                }
            });
        });
        return function(path) {
            return _ref.apply(this, arguments);
        };
    }(),
    post: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(path, payload) {
            var options, defaultData, _tmp, ref, err, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : _tmp, defaultData = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : [];
                        return [
                            4,
                            (0,await_to_js_es5.to)(client.post(path, payload, options))
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], res = ref[1];
                        return [
                            2,
                            err ? defaultData : res.data
                        ];
                }
            });
        });
        return function(path, payload) {
            return _ref.apply(this, arguments);
        };
    }(),
    put: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(path, payload) {
            var options, defaultData, _tmp, ref, err, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : _tmp, defaultData = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : [];
                        return [
                            4,
                            (0,await_to_js_es5.to)(client.put(path, payload, options))
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], res = ref[1];
                        return [
                            2,
                            err ? defaultData : res.data
                        ];
                }
            });
        });
        return function(path, payload) {
            return _ref.apply(this, arguments);
        };
    }(),
    delete: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
            var options, defaultData, _tmp, ref, err, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = {};
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : _tmp, defaultData = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [];
                        return [
                            4,
                            (0,await_to_js_es5.to)(client.delete(path, options))
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            2
                        ]), err = ref[0], res = ref[1];
                        return [
                            2,
                            err ? defaultData : res.data
                        ];
                }
            });
        });
        return function(path) {
            return _ref.apply(this, arguments);
        };
    }()
});

// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(39334);
;// CONCATENATED MODULE: ./src/components/widgets/widget-lotto-check.js
// import dayjs from 'dayjs';












var WidgetLottoCheck = function(param) {
    var eventDataLayer = param.eventDataLayer;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(null), dateData = ref[0], setDateData = ref[1];
    var ref1 = (0,react.useState)(null), selectdate = ref1[0], setSelectdate = ref1[1];
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, errors = ref2.errors;
    var onSubmit = function(data) {
        var lottos = [
            data.lotto1,
            data.lotto2,
            data.lotto3
        ].filter(function(check) {
            return check.length === 6;
        });
        if (lottos.length === 0) return;
        setSelectdate(data.date);
        utils_client.get("/api/v1.0/lottory/".concat(data.date), {
            params: {
                lottos: lottos
            }
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                var _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                dispatch((_tmp.type = "LOTTO_DATA", _tmp.result = res, _tmp))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var res;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        utils_client.get("/api/v1.0/lottory/selectdate")
                    ];
                case 1:
                    res = _state.sent();
                    setDateData(res);
                    return [
                        2
                    ];
            }
        });
    }), []);
    // console.log(watch('date', 'lotto1', 'lotto2', 'lotto3'));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "widget-lottery-check",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "ตรวจผลสลากกินแบ่งรัฐบาล"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "งวดวันที่"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                name: "date",
                                defaultValue: "",
                                ref: register,
                                className: "form-control",
                                onChange: function(e) {
                                    setSelectdate(e.target.value);
                                },
                                children: dateData === null ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: dateData.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: item.key,
                                            children: item.value
                                        }, index);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "lotto1",
                                className: "form-control",
                                ref: register({
                                    pattern: /^\d{6,}/i
                                }),
                                maxLength: "6",
                                placeholder: "กรอกเลขสลาก ใบที่ 1"
                            }),
                            errors.lotto1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "lotto2",
                                className: "form-control",
                                ref: register({
                                    pattern: /^\d{6,}/i
                                }),
                                maxLength: "6",
                                placeholder: "กรอกเลขสลาก ใบที่ 2"
                            }),
                            errors.lotto2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                name: "lotto3",
                                className: "form-control",
                                ref: register({
                                    pattern: /^\d{6,}/i
                                }),
                                maxLength: "6",
                                placeholder: "กรอกเลขสลาก ใบที่ 3"
                            }),
                            errors.lotto3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "กรุณากรอกเป็นตัวเลข จำนวน 6 หลัก"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: "custom-btn",
                        "aria-label": "Lotto Submit",
                        //! DATALAYER
                        onClick: function() {
                            return (0,send_datalayer/* sendDataLayerGlobal */.dE)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventDataLayer), {
                                data: {
                                    title: (0,helper/* useDateUpdate */.WR)(selectdate),
                                    heading: "ตรวจสลากฯ ของคุณ"
                                }
                            }));
                        },
                        children: "ตรวจสลากฯ ของคุณ"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var widget_lotto_check = (WidgetLottoCheck);


/***/ }),

/***/ 33208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25617);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2777);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);





var WidgetLotteryResult = function() {
    var lottoResult = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.navData) === null || ref === void 0 ? void 0 : ref.result;
    });
    // console.log('lottoResult', lottoResult);
    if (lodash__WEBPACK_IMPORTED_MODULE_3___default().isEmpty(lottoResult === null || lottoResult === void 0 ? void 0 : lottoResult.results)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "lottery-result-box",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "ผลสลากกินแบ่งรัฐบาล"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: lottoResult.date
            }),
            lottoResult.results.map(function(item, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lottery-result-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "lottery-result-item",
                            children: item.lottoNo
                        }),
                        item.award.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                            className: "lottery-result-item",
                            children: [
                                "คุณไม่ถูกรางวัล",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__.FiFrown, {
                                    color: "red"
                                })
                            ]
                        }) : item.award.map(function(data, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h5", {
                                className: "lottery-result-item ".concat(i + 1 > 1 ? "--full" : ""),
                                children: [
                                    "ยินดีด้วย คุณถูก",
                                    data.award,
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            numeral__WEBPACK_IMPORTED_MODULE_2___default()(data.price).format("0,0"),
                                            " บาท"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__.FiSmile, {
                                        color: "green"
                                    })
                                ]
                            }, i);
                        })
                    ]
                }, i);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WidgetLotteryResult);


/***/ }),

/***/ 38864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ WEB_NAME; },
/* harmony export */   "Nt": function() { return /* binding */ WEB_LOGO; },
/* harmony export */   "Pc": function() { return /* binding */ STATIC_FILE; },
/* harmony export */   "TH": function() { return /* binding */ IMAGE_DEFAULT; },
/* harmony export */   "V5": function() { return /* binding */ SOCIAL_LIST; },
/* harmony export */   "a0": function() { return /* binding */ WEB_DESC; },
/* harmony export */   "h$": function() { return /* binding */ WEB_URL; },
/* harmony export */   "kG": function() { return /* binding */ WEB_KEYWORD; },
/* harmony export */   "qN": function() { return /* binding */ WEB_TITLE; },
/* harmony export */   "zK": function() { return /* binding */ IMAGE_NAME; }
/* harmony export */ });
/* unused harmony export ADDRESS_ORG */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78633);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52091);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);




/* -------------------------------------------------------------------------- */ /*                                   HEADER                                   */ /* -------------------------------------------------------------------------- */ var IMAGE_NAME = "logo-192.png"; // logo-192.png
var IMAGE_DEFAULT = "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_IMG */ .T, "/default.jpg"); // default image
var WEB_TITLE = "ข่าวด่วน ข่าวล่าสุด ข่าววันนี้ วิเคราะห์ข่าวเศรษฐกิจ โดยกรุงเทพธุรกิจ";
var WEB_DESC = "กรุงเทพธุรกิจออนไลน์ นำเสนอข่าววันนี้ ข่าวด่วน ข่าวล่าสุดทั้งหมด เกี่ยวกับข่าวธุรกิจ ข่าวการเงิน ข่าวการค้า วิเคราะห์ข่าวเศรษฐกิจ ข่าวการลงทุน เพื่อการตัดสินใจอย่างมืออาชีพ";
var WEB_KEYWORD = "อ่านข่าวออนไลน์, กรุงเทพธุรกิจ, ข่าวเด่นประจำวัน, ข่าวโซเซียล, ข่าวธุรกิจ, การเงิน, เศรษฐกิจต่างประเทศ, คลิปข่าว, ข่าวบันเทิง";
var WEB_NAME = "bangkokbiznews";
var WEB_LOGO = "logo.png";
// export const TWITTER = {
//   HANDLE: 'กรุงเทพธุรกิจ',
//   SITE: '@ktnewsonline'
// };
var STATIC_FILE = {
    FB_APP_ID: "192332974272649",
    FB_PAGES: "135182934814",
    ICON_LOGO: "logo.svg",
    ICON_MASK: "bangkokbiznews.png",
    ICON_FAV: "favicon.ico",
    ICON_APPLE: "apple-touch-icon.png"
};
/* -------------------------------------------------------------------------- */ /*                                   FOOTER                                   */ /* -------------------------------------------------------------------------- */ var WEB_URL = {
    WEB: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .APP_URL */ .FX, "/"),
    FACEBOOK: "https://www.facebook.com/bangkokbiznews",
    TWITTER: "https://twitter.com/ktnewsonline",
    YOUTUBE: "https://www.youtube.com/channel/UCwAoYpzi-LmKhRXlW4bMdBA",
    LINE: "https://line.me/R/ti/p/%40rvb8351i",
    INSTAGRAM: "https://www.instagram.com/bangkokbiznews/"
};
var ADDRESS_ORG = {
    CONTENT: "บริษัท กรุงเทพธุรกิจ มีเดีย จำกัด 1858/126 ชั้นที่ 30 ถนนเทพรัตน แขวงบางนาใต้ เขตบางนา",
    PROVINCE: "กรุงเทพฯ",
    REGION: "TH",
    POSTCODE: "10260",
    COUNTRY: "THAILAND"
};
var SOCIAL_LIST = [
    {
        id: 1,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_2__/* .FaFacebookF */ .tBk, {
            id: "facebook",
            size: 16
        }),
        link: WEB_URL.FACEBOOK,
        name: "facebook",
        className: "icon-facebook"
    },
    {
        id: 2,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsTwitterX */ .AMt, {
            id: "x",
            size: 16
        }),
        link: WEB_URL.TWITTER,
        name: "x",
        className: "icon-x"
    },
    {
        id: 3,
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_3__/* .BsLine */ .GF9, {
            id: "line",
            size: 16
        }),
        link: WEB_URL.LINE,
        name: "line",
        className: "icon-line"
    }
];


/***/ }),

/***/ 51148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* eslint-disable no-unused-vars */ 





function useUser() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), result = ref[0], setResult = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isLogin = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-state");
        var cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
        var getUser = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var response, _tmp, _tmp1, res, _tmp2, _tmp3, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                6,
                                7
                            ]);
                            _tmp = {};
                            return [
                                4,
                                fetch("/api/auth/me", (_tmp.method = "GET", _tmp.headers = {
                                    "Content-Type": "application/json"
                                }, _tmp))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!(!response.ok || response.status === 204 || response.statusText === "No Content")) return [
                                3,
                                2
                            ];
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("login-state");
                            _tmp1 = {};
                            setResult(_tmp1);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                response.json()
                            ];
                        case 3:
                            res = _state.sent();
                            _tmp2 = {};
                            js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("login-data", res, (_tmp2.secure = true, _tmp2.expires = Number(src_constants__WEBPACK_IMPORTED_MODULE_3__/* .NEXT_PUBLIC_LOGIN_COOKIE_DATE */ .B6), _tmp2)); //, { expires: 1, sameSite: 'strict', secure: true, httpOnly: true }
                            _tmp3 = {};
                            setResult((_tmp3.user = res, _tmp3));
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                7
                            ];
                        case 5:
                            error = _state.sent();
                            setError(error);
                            return [
                                3,
                                7
                            ];
                        case 6:
                            setLoading(false);
                            return [
                                7
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getUser() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && !lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            var cook = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("login-data");
            setResult({
                user: cook
            });
        } else if (!lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(isLogin) && lodash__WEBPACK_IMPORTED_MODULE_1___default().isEmpty(cookies)) {
            getUser();
        }
    }, []);
    return result;
}
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);